<template>
	<div>
		<!-- 查询条件 -->
		<el-dialog title="变量值翻译" :visible.sync="dialogListVisible" width="1000px" :close-on-click-modal="false" :before-close="handleClose">
			<el-col :span="24" class="handleQuery">
				<el-form :inline="true" :model="addOrUpdateForm"  class="form" :rules="rules"  size="small"  ref="addOrUpdateForm" label-width="80px">
					<el-form-item label="变量名" prop="variableTitle"><el-input disabled type="text" v-model="addOrUpdateForm.variableTitle"></el-input></el-form-item>
					<el-form-item label="变量值" prop="variableValue"><el-input type="text" v-model="addOrUpdateForm.variableValue"></el-input></el-form-item>
					<el-form-item label="翻译值" prop="translateValue"><el-input type="text" v-model="addOrUpdateForm.translateValue"></el-input></el-form-item>
					<el-button size="small" type="primary" @click="handleUpdate">添加</el-button>
				</el-form>
				
			</el-col>

			<!-- 列表 -->
			<el-col :span="24">
				<el-table v-loading="loading" :data="datas" stripe border style="width: 100%" ref="multipleTable" tooltip-effect="dark" @selection-change="handleSelectionChange"
					@sort-change="sortChange" :default-sort="queryParams.defaultSort">
					<el-table-column prop="variableValue" label="变量值"></el-table-column>
					<el-table-column prop="translateValue" label="翻译值"></el-table-column>
					<el-table-column fixed="right" label="操作" width="80">
						<template slot-scope="scope">
							<el-button size="mini" type="text" @click="batchUpdateStatus(-1,'删除',scope.row.id)" v-has="'btn_del'">删除</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!-- 分页 -->
				<el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50, 100]" :current-page="queryParams.currentPage"
					:page-size="queryParams.pageSize" :total="totalNum" @size-change="pageSizeChange" @current-change="pageCurrentChange"></el-pagination>
			</el-col>


		</el-dialog>


	</div>
</template>
<script>
	import BaseSearch from '@/components/layout/base/base-search-front';

	export default {
		extends: BaseSearch,
		name: 'templateTriggerList',
		props: ['dialogListVisible', 'params'],
		data() {
			return {
				url: 'template/variable/translate',
				rules: {
					variableId: [{
							required: true,
							message: '请输入变量id',
							trigger: 'blur'
						},
						{
							max: 20,
							message: '长度最长支持20',
							trigger: 'blur'
						}
					],
					variableValue: [{
							required: true,
							message: '请输入变量值',
							trigger: 'blur'
						},
						{
							max: 20,
							message: '长度最长支持20',
							trigger: 'blur'
						}
					],
					translateValue: [{
							required: true,
							message: '请输入翻译值',
							trigger: 'blur'
						},
						{
							max: 50,
							message: '长度最长支持50',
							trigger: 'blur'
						}
					],
				}
			};
		},
		filters: {
			formatTriggerCondition(data) {
				if (data) {
					var condition = data.triggerCondition
					if (data.triggerCondition) {
						if (condition.includes('A')) {
							condition = condition.replace('A', data.a)
						}
						if (condition.includes('B')) {
							condition = condition.replace('B', data.b)
						}
						return condition
					}
				}
			},
			formatType(type) {
				if (type == "device") {
					return '设备'
				}
			}
		},
		methods: {
			beforeQuery() {
				this.queryParams.variableId = this.params.variableId
				this.addOrUpdateForm.variableId = this.params.variableId
				this.addOrUpdateForm.variableTitle = this.params.variableTitle
			},
			beforeEdit(){
				this.addOrUpdateForm.variableId = this.params.variableId
			},
			handleClose() {
				this.$emit("update:dialogListVisible", false);
			}
		},
		mounted: function() {

		}

	}
</script>

<style scoped>
	.el-dialog__body {
		display: grid;
		padding-top: 0px;

		.form {
			margin: 10px 0px 10px 0px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/layout/devices/variableTranslate.vue